// extracted by mini-css-extract-plugin
module.exports = {"actions":"answer-actions_actions__1kzQK","col--votes":"answer-actions_col--votes__1-uxG","col--share":"answer-actions_col--share__2ba-V","action":"answer-actions_action__3Zz13"};